export const getBaseUrl = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';
